<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    class="icon"
    viewBox="0 0 24 24"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M3.6001 12C3.6001 12 6.1201 6 12.0001 6C17.8801 6 20.4001 12 20.4001 12C20.4001 12 17.8801 18 12.0001 18C6.1201 18 3.6001 12 3.6001 12ZM12.0001 15.9C14.154 15.9 15.9001 14.1539 15.9001 12C15.9001 9.84609 14.154 8.1 12.0001 8.1C9.84619 8.1 8.1001 9.84609 8.1001 12C8.1001 14.1539 9.84619 15.9 12.0001 15.9Z"
    />
    <path
      d="M14.1001 12C14.1001 13.1598 13.1599 14.1 12.0001 14.1C10.8403 14.1 9.9001 13.1598 9.9001 12C9.9001 10.8402 10.8403 9.9 12.0001 9.9C13.1599 9.9 14.1001 10.8402 14.1001 12Z"
    />
  </svg>
</template>

<script>
export default {
  name: 'IconEye',
};
</script>

<style scoped>
.icon {
  display: inline-block;
  width: 1.5em;
  height: 1.5em;
  fill: inherit;
  flex-shrink: 0;
}
</style>
